import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc936ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board-map-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["id"]

import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue'
import Text from '@/components/text'
import EZUIKit from 'ezuikit-js'
import { CODE_ENUM } from '@/common'
import { queryBoardVideoDetail } from '@/api'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'b-live',
  props: ['id', 'name'],
  emits: ['on-edit', 'on-delete'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t



const command = (command: any) => {
  $emit(command)
}

const themeData = {
  header: {
    color: '#1890ff',
    activeColor: '#FFFFFF',
    backgroundColor: '#000000',
    btnList: [],
  },
  footer: {
    color: '#FFFFFF',
    activeColor: '#1890FF',
    backgroundColor: '#00000021',
    btnList: [
      {
        iconId: 'play',
        part: 'left',
        defaultActive: 1,
        memo: t('STATISTICS.bplay'),
        isrender: 1,
      },
      {
        iconId: 'capturePicture',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.bscreenshotBtn'),
        isrender: 1,
      },
      {
        iconId: 'sound',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.bsoundBtn'),
        isrender: 1,
      },
      {
        iconId: 'recordvideo',
        part: 'left',
        defaultActive: 0,
        memo: t('STATISTICS.brecordBtn'),
        isrender: 1,
      },
      {
        iconId: 'hd',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bhdBtn'),
        isrender: 1,
      },
      {
        iconId: 'webExpend',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bwebExpend'),
        isrender: 1,
      },
      {
        iconId: 'expend',
        part: 'right',
        defaultActive: 0,
        memo: t('STATISTICS.bexpendBtn'),
        isrender: 1,
      },
    ],
  },
}

const videoId = ref('board-video-')
onMounted(async () => {
  nextTick(() => {
    queryDetail()
  })
})

let player: any = null
const queryDetail = async () => {
  const id = props.id
  const res: any = await queryBoardVideoDetail({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { accessToken, address } = res.data
    player = new EZUIKit.EZUIKitPlayer({
      id: videoId.value + props.id, // 视频容器ID
      accessToken,
      url: address,
      width: 762,
      height: 276,
      // template: 'pcLive',
      themeData,
      handleError: (err: any) => {
        console.log(err)
      },
    })
  }
}

onUnmounted(() => {
  player?.stop?.()
})

return (_ctx: any,_cache: any) => {
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Text), {
        content: props.name
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.name), 1)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_el_dropdown, {
        onCommand: command,
        size: "small",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "on-edit" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bedit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "on-delete" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.bdel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "icon" }, {
            default: _withCtx(() => [
              _createVNode(_component_MoreFilled)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "video",
      id: videoId.value + props.id
    }, null, 8, _hoisted_3)
  ]))
}
}

})